import { PERITADOR_ACT_VALIDATE_REQUEST } from './constants'
import * as clienteActions from '../../clientes/redux/actions'
import { DEFAULT_CLIENT_BUSINESS_TYPE } from '../../clientes/constants'

export function actValidateRequest() {
  return (dispatch, getState) => {
    const { clientes } = getState()
    // validate client
    const isClientUpdated = clientes?.updateClienteSuccess && !clientes?.updateClienteError;
    if (!isClientUpdated){
      dispatch(actValidateRequestClient())
    }

    dispatch({
      type: PERITADOR_ACT_VALIDATE_REQUEST,
      data: isClientUpdated,
    })
  }
}

export function actValidateRequestClient() {
  return (dispatch, getState) => {
    const { peritador } = getState()
    if (peritador?.requestDialogClient?.id) {
      dispatch(clienteActions.setCliente(peritador?.requestDialogClient))
    } else {
      const newCliente = {
        client_type: 'HUMANA',
        client_business_type: DEFAULT_CLIENT_BUSINESS_TYPE,
        address: null,
        business_name: null,
        city: null,
        country: null,
        cuil_cuit: null,
        email: peritador?.requestDialogClient?.email,
        firstname: peritador?.requestDialogClient?.firstname,
        information: null,
        lastname: peritador?.requestDialogClient?.lastname,
        marital_status: null,
        nationality: null,
        ownership_type: null,
        phone: peritador?.requestDialogClient?.phone,
        province: null,
        zip_code: null
      }
      dispatch(clienteActions.addCliente(newCliente))
    }
  }
}

export function reducer(state, action) {
  if (action.type === PERITADOR_ACT_VALIDATE_REQUEST) {
      return {
        ...state,
        requestDialogIsValid: action.data,
      }
  }
  else {
      return state
  }
}
